function parseNoteTime(value) {
  if (!value) return null;
  const ms = Date.parse(String(value));
  return Number.isFinite(ms) ? ms : null;
}

function formatNoteActivityDate(value) {
  const ms = parseNoteTime(value);
  if (ms == null) return "—";
  return new Date(ms).toLocaleDateString();
}

/**
 * Latest note activity for list + modal meta.
 * Updated — last content change. Read — client opened after last update.
 */
export function formatNoteActivityLabel(note) {
  const updatedAt = note?.updated_at || note?.created_at;
  const seenAt = note?.seen_at;
  const updatedMs = parseNoteTime(updatedAt);
  const seenMs = parseNoteTime(seenAt);

  if (seenMs != null && (updatedMs == null || seenMs > updatedMs)) {
    return { kind: "seen", label: "Read", date: formatNoteActivityDate(seenAt) };
  }

  return {
    kind: "updated",
    label: "Updated",
    date: formatNoteActivityDate(updatedAt),
  };
}

export function noteActivityDisplay(note) {
  const { label, date } = formatNoteActivityLabel(note);
  return `${label} ${date}`;
}
